import { createContext, useContext } from "react";
import { CreditsProvider } from "./CreditsContext";
import { useFetchPlans } from "services/mercadopago";

const Plans = createContext();

export function PlansProvider({ children }) {
  const { plans, loading, error } = useFetchPlans();

  return (
    <Plans.Provider value={{ plans, loading, error }}>
      <CreditsProvider plans={plans}>{children}</CreditsProvider>
    </Plans.Provider>
  );
}

export const usePlans = () => useContext(Plans);
